import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { getLastSyncDate } from './investmentPerformanceV2Selectors';
import { mkInvestmentPerformanceV2 } from './investmentPerformanceV2Types';
import * as actions from './investmentPerformanceV2Actions';

export function* getInvestmentPerformanceActionWatcher(): Generator<*, *, *> {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'investment performance',
    resourceBaseUrl: '/v2/investments/performance',
    getLastSyncDate,
    successAction: actions.getInvestmentPerformanceV2Success,
    failureAction: actions.getInvestmentPerformanceV2Failure,
    transformResponseToResources: (response) => response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentPerformanceV2({
      ...data,
      id: data.accountId,
    })),
  });
  yield takeEvery(actions.getInvestmentPerformanceV2, getQcsSyncResources, config);
}

export default [
  getInvestmentPerformanceActionWatcher,
];
